import { createTheme } from '@mui/material/styles';

const getTheme = (mode) => createTheme({
  palette: {
    mode,
    ...(mode === 'dark' 
      ? {
          // Dark mode palette
          primary: {
            main: '#3b82f6',
            light: '#60a5fa',
            dark: '#2563eb',
          },
          secondary: {
            main: '#a855f7',
            light: '#c084fc',
            dark: '#9333ea',
          },
          background: {
            default: '#0f172a',
            paper: '#1e293b',
          },
          text: {
            primary: '#f1f5f9',
            secondary: '#cbd5e1',
          },
          divider: '#334155',
        }
      : {
          // Light mode palette
          primary: {
            main: '#3b82f6',
            light: '#60a5fa',
            dark: '#2563eb',
          },
          secondary: {
            main: '#a855f7',
            light: '#c084fc',
            dark: '#9333ea',
          },
          background: {
            default: '#ffffff',
            paper: '#ffffff',
          },
          text: {
            primary: '#000000',
            secondary: '#666666',
          },
          divider: '#f0f0f0',
        }
    ),
  },
  typography: {
    fontFamily: '"Geist Sans", sans-serif',
    // You can also specify different fonts for different variants
    h1: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    h2: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    h3: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    h4: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    h5: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    h6: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    body1: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    body2: {
      fontFamily: '"Geist Sans", sans-serif',
    },
    button: {
      fontFamily: '"Geist Sans", sans-serif',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          ...(mode === 'dark' 
            ? {
                backgroundColor: '#1e293b',
                border: '1px solid #334155',
              }
            : {
                backgroundColor: '#ffffff',
                border: '1px solid #f0f0f0',
              }
          ),
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          ...(mode === 'dark' 
            ? {
                backgroundColor: '#1e293b',
                border: '1px solid #334155',
              }
            : {
                backgroundColor: '#ffffff',
                border: '1px solid #f0f0f0',
              }
          ),
        },
      },
    },
  },
});

export default getTheme;
